(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react-emotion', './levels', '../../styles/colors'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react-emotion'), require('./levels'), require('../../styles/colors'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.reactEmotion, global.levels, global.colors);
    global.NotificationCss = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _reactEmotion, _levels, _colors) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.animateOut2 = exports.animateOut1 = exports.animateIn = exports.NotificationBox = exports.titlePrefixClass = undefined;

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _reactEmotion2 = _interopRequireDefault(_reactEmotion);

  var _levels2 = _interopRequireDefault(_levels);

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _levelColors;

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n  font-weight: 900;\n  padding: 0 0.2rem;\n'], ['\n  font-weight: 900;\n  padding: 0 0.2rem;\n']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  flex-flow: row nowrap;\n  overflow: hidden;\n  width: 100%;\n\n  border-radius: 3px;\n  padding: 0 0 0 16px;\n  margin-top: -100px;\n  margin-bottom: 10px;\n  font-size: 13px;\n  text-align: left;\n\n  ', ' .material-icons {\n    font-size: 1rem;\n    padding: 23px 0px;\n  }\n\n  .button-close {\n    margin-left: auto;\n    padding-right: 0;\n    cursor: pointer;\n    padding: 23px 16px;\n  }\n'], ['\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  flex-flow: row nowrap;\n  overflow: hidden;\n  width: 100%;\n\n  border-radius: 3px;\n  padding: 0 0 0 16px;\n  margin-top: -100px;\n  margin-bottom: 10px;\n  font-size: 13px;\n  text-align: left;\n\n  ', ' .material-icons {\n    font-size: 1rem;\n    padding: 23px 0px;\n  }\n\n  .button-close {\n    margin-left: auto;\n    padding-right: 0;\n    cursor: pointer;\n    padding: 23px 16px;\n  }\n']);

  // Notification box elements

  var titlePrefixClass = exports.titlePrefixClass = (0, _reactEmotion.css)(_templateObject);

  // Notification Box

  var levelColors = (_levelColors = {}, _levelColors[_levels2.default.success] = {
    backgroundColor: _colors2.default.mint,
    border: 'solid 1px ' + _colors2.default.jungle,
    color: _colors2.default.prussian
  }, _levelColors[_levels2.default.error] = {
    backgroundColor: _colors2.default.rose,
    border: 'solid 1px ' + _colors2.default.dragon + ';',
    color: _colors2.default.dragon
  }, _levelColors[_levels2.default.info] = {
    backgroundColor: _colors2.default.lightPrussian,
    border: 'solid 1px ' + _colors2.default.prussian + ';',
    color: _colors2.default.prussian
  }, _levelColors[_levels2.default.warn] = {
    backgroundColor: _colors2.default.blonde,
    border: 'solid 1px ' + _colors2.default.soil + ';',
    color: _colors2.default.soil
  }, _levelColors);

  var getLevelStyles = function getLevelStyles(_ref) {
    var level = _ref.level;
    return levelColors[level] || levelColors[_levels2.default.info];
  };

  var NotificationBox = exports.NotificationBox = (0, _reactEmotion2.default)('div')(_templateObject2, getLevelStyles);

  var animateIn = exports.animateIn = {
    easing: 'linear',
    marginTop: 0,
    duration: 300
  };

  var animateOut1 = exports.animateOut1 = {
    translateY: '-20%',
    marginBottom: 25,
    duration: 1500
  };

  var animateOut2 = exports.animateOut2 = {
    height: 0,
    paddingTop: 0,
    paddingBottom: 0,
    margin: 0,
    border: 0,
    easing: 'easeOutExpo',
    duration: 1000,
    offset: '-=1000'
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Notifications/Notification.css.js
// module id = 541
// module chunks = 0